class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    // RPECK 28/01/2024 - Get a list of the product ID's
    // --
    // Ref for map https://stackoverflow.com/a/49822981/1143732
    var cartItems = this.querySelectorAll('.cart-item');
    var productIds = Array.prototype.slice.call(cartItems).map((x) => x.getAttribute('data-id'));

    // RPECK 28/01/2024 - If the productIds variable is populated, use it to pull recommended items from the recommendations API
    if(productIds.length > 0) {

      // RPECK 28/01/2024 - Vars
      var why_not_add = this.querySelector('.why_not_add');
      var parser      = new DOMParser();
      var currency    = document.documentElement.getAttribute('currency');

      // RPECK 28/01/2024 - Set the order of productIds to be random
      // This allows us to send a single request to the RecommendedProducts API
      // --
      // Ref: https://stackoverflow.com/a/14676412/1143732
      productIds.sort(function() {return 0.5 - Math.random()});

      // RPECK 28/01/2024 - Send a request to the recommended products endpoint
      // --
      // Ref: https://shopify.dev/docs/api/ajax/reference/product-recommendations
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + productIds[0] + "&limit=6&intent=related")
        .then(response => response.json())
        .then(({ products }) => {
          if (products.length > 0) {

              // RPECK 30/01/2024 - Allocate an array to contain the new elements to be added 
              var elements_to_add = [];

              // RPECK 28/01/2024 - Cycle through the products and output them as an independent form
              products.forEach(function(product){

                // RPECK 30/01/2024 - Variants dropdown
                // This is used to populate the various variants available from the dropdown
                var variants = [`<select name="id">`];

                // RPECK 30/01/2024 - Loop through the product variants (there should be at least one)
                product.variants.forEach(function(variant){

                  // RPECK 30/01/2024 - Add any variants to the dropdown
                  variants.push( `<option value="${variant.id}">${ product.options[0].name }: ${ variant.title }</option>` );
                  
                });

                // RPECK 30/01/2024 - Finish off the variants
                variants.push( `</select>` );

                // RPECK 28/01/2024 - Template for each of the products
                // --
                // Ref: https://www.w3schools.com/js/js_string_templates.asp
                const product_template = `
                  <form action="/cart/add" method="post" class="why_not_add_form">
                    <input type="hidden" name="quantity" value="1"/>
                    <div class="info">
                      <div class="image"><a href="${ product.url }"><img src="${ product.featured_image.replace(/(\.[^.]+)$/i, '_x250$1') }" /></a></div>
                      <div class="title"><a href="${ product.url }">${ product.title }</a></div>
                      <div class="price">${ Shopify.formatMoney(product.price, null, currency) }</div>
                    </div>
                    ${variants}
                    <input type="submit" value="Add" class="btn button button--primary" />
                  </form>
                `;

                // RPECK 28/01/2024 - Add the template to the document
                if(why_not_add) {

                  // RPECK 28/01/2024 - Parse the template
                  var parsed_template = parser.parseFromString(product_template, "text/html");

                  // RPECK 28/01/2024 - Append the parsed template node
                  elements_to_add.push( parsed_template.body.querySelector("form") );
                  
                } 
                
            });

            // RPECK 30/01/2024 - If child elements exist, replace them in the why_not_add container
            if(elements_to_add && elements_to_add.length > 0 && why_not_add) why_not_add.querySelector('.forms').replaceChildren( ...elements_to_add );
            
          }
        }
      );
      
    }
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
